module.exports = __webpack_public_path__ + "media/application/images/svgs/menu-db38d57ad71f3c236e38a02d23a65254.svg";